import React from 'react';
import './AwosMessage.css';

function AwosMessage(props) {
  const phoneHref = 'tel:' + props.phone.replace(/[\(\)]/g, '').replace(' ', '-');

  return (
    <div className="phone-container">
      <div className="voice-message">
        For official data, you can call to hear the automated AWOS voice message.
      </div>
      <a href={phoneHref} className="phone-bttn">{props.phone}</a>
      <div className="disclaimer">
        * The data displayed is for advisory purposes only and is not to be use for flight planning or operations.
      </div>
    </div>
  );
}

export default AwosMessage;


/** WEBPACK FOOTER **
 ** ./src/AwosMessage/AwosMessage.js
 **/